import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { Button, Form, Container, Row, Col, Card } from "react-bootstrap";

const LoginScreen = ({ login, isLoggedIn }) => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    if ( isLoggedIn ) {
      navigate("/")
    }

    window.scrollTo(0, 0);
  }, [isLoggedIn, navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    login(email, password);
  };

  return (
    <Container className="auth-page">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="auth-card">
            <Card.Body>
              <Form onSubmit={handleSubmit}>
                <h3 className="page-title">Personal Login</h3>
                <p className="page-subtitle mb-4">Access your account to manage bookings and courses.</p>
                <Form.Group className="mb-3" controlId="formEmail">
                  <Form.Label>Email</Form.Label>
                  <Form.Control type="email" required placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} tabIndex={1}/>
                </Form.Group>
                <Form.Group className="mb-4" controlId="formPassword">
                  <Form.Label>Password <Link className="ms-2" to="/forgot-password">Forgot Password?</Link></Form.Label>
                  <Form.Control type="password" required placeholder="Enter password" autoComplete="true" value={password} onChange={(e) => setPassword(e.target.value)} tabIndex={2}/>
                </Form.Group>
                <Button variant="primary" type="submit" tabIndex={3}>
                  Login
                </Button>

                <Form.Text className="auth-links" muted>
                  Don't have an account? <Link to="/register" tabIndex={4}>Register</Link>
                </Form.Text>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default LoginScreen;
